import React from 'react';
import { getSiteAuditIcons } from 'src/common/config/FunctionHelper';
import TitleTooltip from 'src/components/UI/TitleTooltip';
import { ContentStrategyAISummaryV2 } from '../../types/content-strategy-v2.type';

interface AISummaryProps {
  summary?: ContentStrategyAISummaryV2 | string;
}

const getSummaryText = (
  summary?: ContentStrategyAISummaryV2 | string
): string => {
  if (!summary) return 'No summary available.';
  if (typeof summary === 'string') return summary;
  if (typeof summary === 'object' && summary.text) return summary.text;
  return 'No summary available.';
};

const AISummary: React.FC<AISummaryProps> = ({ summary }) => {
  const summaryText = getSummaryText(summary);

  return (
    <div className="px-6 py-2">
      <div className="flex items-center gap-2">
        <TitleTooltip>
          <TitleTooltip.Text
            title="AI Summary"
            className="!text-[var(--color-text-secondary)] !font-medium !text-base"
          >
            <TitleTooltip.Tooltip
              tooltip={
                <p className="text-primary text-sm font-medium">
                  AI-generated strategic summary highlighting your website's organic visibility status, content gaps, and high-impact growth vectors.
                </p>
              }
            />
          </TitleTooltip.Text>
        </TitleTooltip>
      </div>

      <div className="mt-3 flex items-start gap-4">
        <div className="shrink-0 mt-0.5">
          <img
            src={getSiteAuditIcons('ai-visibility.svg')}
            className="w-10 h-10 object-contain"
            alt="AI Summary"
          />
        </div>
        <div className="flex-1">
          <p className="text-sm text-[#344054] leading-relaxed m-0 font-normal">
            {summaryText}
          </p>
        </div>
      </div>
    </div>
  );
};

export default AISummary;